import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert, Confirm, ComPhoto, NoResult } from "../../../js/ComponentManager";

/* 개발담당:양유빈
 * 화면기능:거래처 리스트
 * 세부설명:
*/

export class AccountList extends Component {
    static displayName = AccountList.name;

    constructor(props) {
        super(props);
        this.state = {
            WholeList: [],
            Search_Text: "",
            Search_Type: "reg_dt",
            Title: "",
            Content:""
        };
        this.CsName = Big3Common.ContentState;
        this.handleDelete_Click = this.handleDelete_Click.bind(this);
        this.handleSearch_Change = this.handleSearch_Change.bind(this);
        this.handleStore_Click=this.handleStore_Click.bind(this);
    }
    //초기화
    componentDidMount() {

        //상세화면 이동후 돌아왔을때 값 설정
        const proSearchText= Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.SearchText, "");
        const proSearchType= Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.SearchType, "");
        this.setState({
            Search_Text:proSearchText,
            Search_Type:proSearchType==="" ? "reg_dt" : proSearchType
        });

        this.CallMyWholeListData(proSearchText,proSearchType);
    }
    //*********내거래처 조회[s]
    async CallMyWholeListData(Search_Text,Search_Type) {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/MyPage/MyInfoMgr/GetMyWholeList',
                {
                    "search_text": Search_Text,
                    "search_type": Search_Type,
                    "appr_status": "AP"
                }
            );
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ WholeList: JSON.parse(Data.dataTable) });
            }
        }
        catch (e) {
            console.log("CallMyWholeListData", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    async handleSearch_Change(event) {
        let tagId = event.target.id;
        if (tagId === "searchCombo") {
            let ComboVal = event.target.value;
            this.setState({Search_Type:ComboVal});
            await this.CallMyWholeListData(this.state.Search_Text,ComboVal);
        }
        else if (tagId === "searchText") {
            if(event.keyCode === 13)
            {
                let textVal = event.target.value;
                this.setState({Search_Text:textVal});
                await this.CallMyWholeListData(textVal,this.state.Search_Type);
            }
        }
        return false;
    }//*********내거래처 조회[e]

    //**************거래중지[s]
    delData= {
        "uid": "",
        "union_uid": "",
        "appr_status":"CA"
    }
    handleDelete_Click(list) {
        this.delData.uid = list.uid;
        this.delData.union_uid = list.union_uid;
        Big3Common.ModalAlert(bootstrap, 'ConfirmBox');
        return false;
    }
    async DeleteRetailGrupApprStatus() {
        try {
            let Data = await Big3Common.Post("api/MyPage/MyInfoMgr/ModifyRetailGrupApprStatus", this.delData,false);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.CallMyWholeListData(this.state.Search_Text,this.state.Search_Type);
            }
            else {
                this.setState({
                    Title: "거래중지 안내",
                    Content:"거래를 중지 오류가 발생 했습니다.<br/>관리자에 문의 하세요."
                })
                Big3Common.ModalAlert(bootstrap, 'AlertBox');
            }
            return false;
        }
        catch (e) {
            console.log("DeleteRetailGrupApprStatus",e)
        }
    }//**************거래중지[e]
    //매장상세 이동
    handleStore_Click(uid){
         this.props.RenderComponent("StoreDtl", {
                [this.CsName.Uid]: uid,
                [this.CsName.BackUrl]: "AccountList",
                [this.CsName.SearchText]:this.state.Search_Text,
                [this.CsName.SearchType]:this.state.Search_Type
            });
    }
    WholeLink(list) {
        if (Big3Common.Util.isEmptyOrNull(list.uid)) {
            this.setState({
                Title: "거래처보기 안내",
                Content: `${list.whole_name}는 플랫폼에 가입된 도매가 아닙니다.`
            })
            Big3Common.ModalAlert(bootstrap, 'AlertBox');
            return false;
        }
        else {
            return (
                <div className="alert_img" onClick={(e)=>{this.handleStore_Click(list.uid)}}>
                   <ComPhoto className="alert_img_in" Photo={list.photo} />
                </div>
            )
        }
    }
    WholeListrender(Datalist) {
        return (
            <>
                {
                    Datalist.map((list,idx) =>
                        <div className="alert_content_v2 alert_content" key={idx}>
                            {this.WholeLink(list)}
                            <div className="alert_txt">
                                <div className="shop_name">{list.whole_name }</div>
                                <div className="shop_address">{`${list.bld_name} ${list.flr_name} ${list.whole_no_name}호`}</div>
                                <div className="order_btn or_btn1" onClick={(event) => { this.props.RenderComponent('DealHistory',{[this.CsName.Uid]: list.uid}); event.preventDefault();}}>거래내역</div>
                                <div className="order_btn or_btn2" onClick={() => this.handleDelete_Click(list)}>거래중지</div>
                                <Link to={`/Chat/LiveChat/Index?uid=${list.uid}`}>
                                    <div className="chat_icon2"></div>
                                </Link>
                            </div>
                        </div>
                    )}
            </>
        );
    }
    render() {
        let WholeListrender = this.WholeListrender(this.state.WholeList);
        return (
            <>
                <div className="tap_box">
                    <div className="t_tap"><div className="alert_tap tap_on">내 거래처</div></div>
                    <div className="t_tap"><div className="alert_tap" onClick={(e) => { this.props.RenderComponent('ApprovalList'); e.preventDefault(); }}>승인대기</div></div>
                    <div className="t_tap"><div className="alert_tap" onClick={(e) => { this.props.RenderComponent('WholeRequest'); e.preventDefault(); }}>거래처 등록</div></div>
                </div>
                <div className="container_box a_margin u_padding">
                    <div className="search_box_v2">
                        <div className="search_input_box">
                            <input type="text" placeholder="도매명을 입력해주세요."
                                id="searchText"
                                className="form-control"
                                defaultValue={this.state.Search_Text}
                                onKeyUp={this.handleSearch_Change}
                            />
                            <div className="search_btn" onClick={this.handleSearch_Change}></div>
                        </div>
                        <div className="order_select_box">
                            <select onChange={this.handleSearch_Change} id="searchCombo" value={this.state.Search_Type} >
                                <option value="reg_dt">최근 등록순</option>
                                <option value="lastdel_dt">최근 거래순</option>
                                <option value="mon_trunover">거래액 높은순</option>
                                <option value="mon_ordnumber">거래횟수 많은순</option>
                            </select>
                            <div className="select_btn"></div>
                        </div>
                    </div>
                    {WholeListrender}
                </div>
                <Confirm
                    id="ConfirmBox"
                    title="거래중지 안내"
                    content="정말로 거래를 중지하시겠습니까?<br/>거래중지 시 상품이 노출되지 않을 수 있습니다."
                    ConfirmClick={(e) => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'ConfirmBox');
                        }, 500);

                        this.DeleteRetailGrupApprStatus();
                    }}
                />
                <Alert
                    id="AlertBox"
                    title={this.state.Title}
                    content={this.state.Content}
                />
                <NoResult
                    Visible={this.state.WholeList.length === 0 ? true : false}
                    Top={"50%"}
                />
            </>
        );
    }
}
